export default "__VITE_ASSET__XIIcFOEF__"